import { CardPaper } from 'shared/ui/card-paper';
import { CityInfoDto, MediaBasicDataDto, RegionInfoDto } from '@sr/dto';
import { LinkToMedia } from 'shared/ui/links/link-to-media';
import { MediaChildCreateDialog } from './media-child-create-dialog';
import { Button } from '@mui/material';
import { useState } from 'react';
import { useCreateMediaChild } from 'entities/media/media-basic-data';
import { useSnack } from 'shared/ui/snack';
import { extractNestJsErrorMessage } from 'shared/api/rtk-query';

type Props = {
  media?: MediaBasicDataDto;
}

export const ParentMediaCard = ({ media }: Props) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  
  const { showSuccess, showError } = useSnack();
  const createMediaChild = useCreateMediaChild(); 
  
  const handleAddMediaChild = async (formValues: any) => {
    try {
      await createMediaChild({
        ...formValues, 
        media: media,
        cities: formValues.cities?.map((city: CityInfoDto) => city.id) || [],
        regions: formValues.regions?.map((region: RegionInfoDto) => region.id) || []
      }).unwrap();
      
      showSuccess('Дочерние СМИ успешно созданы');
      setIsDialogOpen(false);
    } catch (e: any) {
      showError(`Ошибка создания дочерних СМИ: ${extractNestJsErrorMessage(e)}`);
    }
  };

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  return (
    <>
      <CardPaper sx={{ p: 2, textAlign: 'center' }}>
        {media?.parentMedia ? (
          <>СМИ является дочерним для&nbsp;
            <LinkToMedia media={media.parentMedia}>
              {media.parentMedia.name}
            </LinkToMedia>
          </>
        ) : (
          <Button 
            variant='contained' 
            fullWidth
            onClick={handleOpenDialog}
          >
            Создать дочерние СМИ
          </Button>
        )}
      </CardPaper>

      <MediaChildCreateDialog 
        open={isDialogOpen}
        onClose={handleCloseDialog}
        onSubmit={handleAddMediaChild}
      />
    </>
  );
};
